import Paper from '@material-ui/core/Paper';
import React from 'react';
import styled from 'styled-components';

import FigCaption from '../common/FigCaption';

const SmallPatternCard = ({ caption, src }) => {
    const StyledSmallPatternCard = styled(Paper)`
        line-height: 0;
        max-width: 150px;
        & img {
          width: 100%;
          height: auto;
        }
    `;

    return (
        <StyledSmallPatternCard elevation={1}>
            <img src={src} alt={caption} />
        </StyledSmallPatternCard>
    );
};

export default SmallPatternCard;



// WEBPACK FOOTER //
// ./src/components/pattern/SmallPatternCard.js